import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import HeaderConfig from '../../../../constants/header';
import ivclass from '../../../../Modules/IVClass';
import { translate } from '../../../../utils/common';
import GlobalConfig from '../../../../lib/GlobalConfig';
const MenuCTAsContainer = (props) => {
    const { menu, onMenuSelection, onMenuClick, nestedItemClass, leafItemClass } = props;
    return (_jsx(React.Fragment, { children: Object.keys(menu).map((menuItem, index) => {
            const { name, type, url, external, color } = menu[menuItem];
            const itemUrl = translate(`host_url`, { host_url: GlobalConfig.HOST_URL }, { default: url });
            return (_jsxs(React.Fragment, { children: [type === 'nested' && (_jsxs("span", { className: ivclass('iv-header-link ', color ? color : 'iv-text-grey-50', nestedItemClass), onMouseOver: event => onMenuSelection(event, menuItem), children: [name, _jsx("img", { src: HeaderConfig.ANGLE_BOTTOM_ICON_DESKTOP.url, alt: HeaderConfig.ANGLE_BOTTOM_ICON_DESKTOP.alt, height: HeaderConfig.ANGLE_BOTTOM_ICON_DESKTOP.height, width: HeaderConfig.ANGLE_BOTTOM_ICON_DESKTOP.width, className: ivclass('iv-inline-block iv-ml-8') })] }, menuItem)), type === 'leaf' && (_jsx("a", { href: itemUrl, className: ivclass(leafItemClass), onClick: e => {
                            e.preventDefault();
                            onMenuClick(menuItem, external, itemUrl);
                        }, children: name }, name))] }, name));
        }) }));
};
export default MenuCTAsContainer;
